import { Component } from '@angular/core'

@Component({
  selector: 'lin-dashboard-section',
  template: '<ng-content></ng-content>',
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 15px;
      }
    `,
  ],
  standalone: false,
})
export class DashboardSectionComponent {}
